
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media-and-events",
      function () {
        return require("private-next-pages/media-and-events.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media-and-events"])
      });
    }
  